/*eslint-disable*/
import UserApi from '../../api/user/user.js';

export default {
    data() {
        return {
            amountOfUnread: null,
            amountOfFavorites: null
        };
    },
    mounted() {
        this.getAmounts();
    },
    watch: {
        amountOfUnread (val, oldVal) {
            if (!this.isSidebar) {
                this.$root.amountOfUnread = val;
            }
        }
    },
    methods: {
        getAmounts() {
            this.isAmountsLoading = true;
            if (!this.$offline) {
              UserApi.amountsOfMessages()
                .then(data => {
                  this.amountOfUnread = data.data.amountOfUnread;
                  this.amountOfFavorites = data.data.amountOfFavorites;
                  this.isAmountsLoading = false;
                })
                .catch(() => {
                  this.isAmountsLoading = false;
                })
            }
        }
    }
}
